import { ErrorInfoModel } from "../models/service/error-info.model";
import { CommonChecks } from "../utilities/common-checks.utilities";

export type AppInsightsTracker = (error: Error, errorInfo?: ErrorInfoModel) => void;

export class ErrorHandler {

  private static appInsightsTracker?: AppInsightsTracker;

  public static registerAppInsightsTracker(tracker: AppInsightsTracker): void {
    ErrorHandler.appInsightsTracker = tracker;
  }

  public static handleError(error: Error, errorInfo?: ErrorInfoModel): void {

    if (CommonChecks.isNullOrUndefined(errorInfo) || (errorInfo!.noLogging != true)) {
      this.logErrorToConsole(error, errorInfo);

      this.logErrorToAppInsights(error, errorInfo);
    }

    if (!CommonChecks.isNullOrUndefined(errorInfo) && errorInfo!.redirect === true) {
      //redirect to error page
    }

  }

  private static logErrorToConsole(error: Error, errorInfo?: ErrorInfoModel): void {
    var prefixInfo = "";

    if (!CommonChecks.isNullOrUndefined(errorInfo)) {
      prefixInfo = `Redirect: ${errorInfo?.redirect} RedirectOverrrideUri: ${errorInfo?.redirectOverrideUri} Swallow: ${errorInfo?.swallow} `;
    }

    console.error(prefixInfo, error);
  }

  private static logErrorToAppInsights(error: Error, errorInfo?: ErrorInfoModel): void {
    ErrorHandler.appInsightsTracker?.(error, errorInfo);
  }

}

export default ErrorHandler;
